/** @format */

import { TOGGLE_THEME, TOGGLE_SEARCH, TOGGLE_GENRE } from "../variables";

export function UiReducer(state, action) {
  switch (action.type) {
    case TOGGLE_THEME:
      localStorage.setItem("isDarkMode", !state.isDarkMode);
      return { ...state, isDarkMode: !state.isDarkMode };

    case TOGGLE_SEARCH:
      return { ...state, isSearchOpen: !state.isSearchOpen };

    case TOGGLE_GENRE:
      return { ...state, isGenreOpen: !state.isGenreOpen };

    default:
      return state;
  }
}
